import { render, staticRenderFns } from "./AbilityReport.vue?vue&type=template&id=840a56f6&scoped=true"
import script from "./AbilityReport.vue?vue&type=script&lang=js"
export * from "./AbilityReport.vue?vue&type=script&lang=js"
import style0 from "./AbilityReport.vue?vue&type=style&index=0&id=840a56f6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "840a56f6",
  null
  
)

export default component.exports